// src/routes/index.tsx
import React from "react";
import {
  Dashboard,
  LoginPage,
  RoleSelectionPage,
  UnitSelectionPage,
  ApartmentSelectionPage,
  PendingPayment,
  PackagesPage,
  PetsPage,
  CreatePetPage,
  AdminConfigPage,
  ChangePasswordPage,
  UserProfilePage,
  RecoverPasswordStep1,
  RecoverPasswordStep2,
  EncomiendaListPage,
  PqrListPage,
  DesperfectoListPage,
  VisitorsPage,
  CreateVisitorPage,
  LostPetsPage,
  VehiclesPage,
  TableroListPage,
  TableroDetailPage,
  ApartamentosPage,
  DiasHabilesZonaComunPage,
  ZonasComunesListPage,
  AsambleaListPage,
  ReservaListPage,
  TurnosZonaComunPage,
  ConfigurarSOSPage,
  ConfigurarSistemaPage,
  InformacionGeneralPage,
} from "../pages";

// Rutas públicas (sin autenticación)
export const publicRoutes = [
  { path: "/", element: <LoginPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/recover-password-step1", element: <RecoverPasswordStep1 /> },
  { path: "/recover-password-step2", element: <RecoverPasswordStep2 /> },
  { path: "/UnitSelectionPage", element: <UnitSelectionPage /> },
  { path: "/RoleSelectionPage", element: <RoleSelectionPage /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/ApartmentSelectionPage", element: <ApartmentSelectionPage /> },
  { path: "/PendingPayment", element: <PendingPayment /> },
  { path: "/PackagesPage", element: <PackagesPage /> },
  { path: "/PetsPage", element: <PetsPage /> },
  { path: "/PetsPage/CreatePetPage", element: <CreatePetPage /> },
  { path: "/AdminConfigPage", element: <AdminConfigPage /> },
  { path: "/ChangePasswordPage", element: <ChangePasswordPage /> },
  { path: "/UserProfilePage", element: <UserProfilePage /> },
  { path: "/encomiendas", element: <EncomiendaListPage /> },
  { path: "/pqr", element: <PqrListPage /> },
  { path: "/desperfectos", element: <DesperfectoListPage /> },
  { path: "/visitantes", element: <VisitorsPage /> },
  { path: "/visitantes/crear", element: <CreateVisitorPage /> },
  { path: "/mascotas-perdidas", element: <LostPetsPage /> },
  { path: "/vehiculos", element: <VehiclesPage /> },
  { path: "/tablero", element: <TableroListPage /> },
  { path: "/tablero/:tipoCodigo/:codigo", element: <TableroDetailPage /> },
  { path: "/apartamentos", element: <ApartamentosPage /> },
  { path: "/zona-comun/:codigo/dias-habiles", element: <DiasHabilesZonaComunPage /> },
  { path: "/zonas-comunes", element: <ZonasComunesListPage /> },
  { path: "/asambleas", element: <AsambleaListPage /> },
  { path: "/reservas", element: <ReservaListPage /> },
  { path: "/zona-comun/:codigo/dias-habiles/:diaCodigo/turnos", element: <TurnosZonaComunPage /> },
  { path: "/configurar-sos", element: <ConfigurarSOSPage /> },
  { path: "/configurar-sistema", element: <ConfigurarSistemaPage /> },
  { path: "/informacion-general", element: <InformacionGeneralPage /> },
];

// Rutas privadas (requieren autenticación)
// export const privateRoutes = [
//   { path: "/dashboard", element: <DashboardPage /> },
// ];
